<script setup lang="ts">
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'

defineProps<{
  visible: boolean
  remainingSeconds: number
}>()

const emit = defineEmits<{
  extend: []
}>()

const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  if (mins > 0) {
    return `${mins}m ${secs}s`
  }
  return `${secs}s`
}
</script>

<template>
  <Dialog
    :visible="visible"
    :closable="false"
    :modal="true"
    header="Session Expiring"
    :style="{ width: '400px' }"
  >
    <div class="flex flex-col items-center gap-4 p-4">
      <i class="pi pi-exclamation-triangle text-5xl text-yellow-500"></i>
      <p class="text-center">
        Your session will expire in <strong>{{ formatTime(remainingSeconds) }}</strong> due to
        inactivity.
      </p>
      <p class="text-center text-sm text-gray-500">
        Click the button below to continue your session.
      </p>
    </div>

    <template #footer>
      <div class="flex justify-center w-full">
        <Button label="Stay Logged In" icon="pi pi-check" @click="emit('extend')" autofocus />
      </div>
    </template>
  </Dialog>
</template>
